import React, { useContext, useEffect, useState, useRef } from "react";
import PageName from "../Utils/PageName";
import { Link, useLocation } from "react-router-dom";
import { environmentVariables } from "../../config/env.config";
import axios from "axios";
import { userContext } from "../../context/userContext";
import ReactDOM from "react-dom";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { businessContext } from "../../context/businessContext";
import { businessObjContext } from "../../context/businessObjContext";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { businessNameContext } from "../../context/businessContext";
import FilterIcon from "../../../src/Images/FilterIcon.png";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import "./../Pages/UpdateRequestcardstyle.css";
import { useCallback, useMemo } from "react";
import { format } from 'date-fns';
import { useTranslation } from "react-i18next";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import moment from "moment";
import { getUserPermission } from "../../utils/utility";

const Adminrestaurantorders = ({dineIn}) => {
  const { t } = useTranslation();
  const location = useLocation()
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseUrl = environmentVariables?.apiUrl;
  const { userData, setUserData } = useContext(userContext);

  const { businessObjData, setBusinessObjData } =
    useContext(businessObjContext);
  const [isLoading, setIsLoading] = useState(true);
  const { businessNameData, setBusinessNameData } =
    useContext(businessNameContext);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
  const [isTable, setIsTable] = useState(false);
  const [initialPaymentStatus, setInitialPaymentStatus] = useState(null);
  const [initialOrderStatus, setInitialOrderStatus] = useState(null);
  const [hasSavedPayment, setHasSavedPayment] = useState(false);
  const [hasSavedOrder, setHasSavedOrder] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [businessId, setBusinessId] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactNoCountryCode, setContactNoCountryCode] = useState("");

  const [businessname, setBusinessname] = useState("");
  const [businessData, setBusinessData] = useState([]);
  const [tempData, setTempData] = useState([]);
  const tableExtensions = { export: false, print: false };
  const [isSubmit, setIsSubmit] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const fromDate = useRef(null);
  const toDate = useRef(null);
  const [action] = useState({ fromUser: false });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [paginationPerPage, setPaginationPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState([]);
  const [activeBusinessName, setActiveBusinessName] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [businesslistData, setBusinesslistData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [activeCountry, setActiveCountry] = useState("");
  const [searchId, setSearchId] = useState("");
  const abortController = new AbortController();
  const storedUserData = localStorage.getItem("user");
  const userDataObject = JSON.parse(storedUserData);
  const closeButtonRef = useRef(null);

  const items = typeof selectedMessage?.items === 'string' ? JSON.parse(selectedMessage.items) : selectedMessage?.items;


  const handleFilterOpen = () => {
    setShowFilter(!showFilter);
  };
  const handleFilterClose = () => {
    setShowFilter(false);
  };


  //////////oreders ///////////////////////////////////////
  const [orders, setOrders] = useState([]);

  const fetchOrders = async (page) => {

    try {
      const response = await axios.get(`${baseUrl}api/v1/business/fetchOrdersByUserId`, {
        headers: {
          _token: userData?.token,
        },
        params: {
          userId: userData.id,
          page: page,
          pageSize: rowsPerPage,
          activeCountry: activeCountry,
          activeBusiness: activeBusinessName,
          searchId: searchId,
          dinein : dineIn
        },
        signal: abortController.signal

      });
      setOrders(response.data.orders);
      setPaginationTotalRows(response?.data?.orders?.count)
      setIsLoading(false);
      setData(response?.data?.orders?.rows)
      setCountryData(response?.data?.countries)
    } catch (error) {
      console.error('Error fetching orders:', error);
      setIsLoading(false);
    }
  };

  ///////////////////orders end //////////////////////////////

 

  const customStyles = {
    dataTableExtensions: {
      backgroundColor: "lightgray",
      padding: "10px",
    },
    headRow: {
      style: {
        backgroundColor: "#e9e9e9",
        borderRadius: "2px 2px 0 0",
        paddingLeft: "25px",
        border: "none",
        textTransform: "capitalize",
        position: "sticky",
        left: 0,
        top: 0,
        zIndex: 1,
        boxShadow: "0 2px 2px -1px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        whiteSpace: "nowrap",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px !important",
      },
    },
    BusinessColumn: {
      position: "sticky",
      left: "0",
      zIndex: "1",
      backgroundColor: "#fff",
      overflow: "hidden",
      whiteSpace: "nowrap",
    }
  };



  const handleOnSelectedRowsChange = useCallback(
    ({ selectedRows }) => {
      if (!action.fromUser) return; //the component always trigger this with 0 selected rows when it renders a page, what would clear the selection

      selectedRowsPerPage[currentPage] = selectedRows; //there is no way to tell if a row was DEselected, so I had to control the selected rows per page,
      //the array would get an index to control each page
      // console.log(JSON.stringify(selectedRowsPerPage));
    },
    [currentPage, selectedRowsPerPage, action.fromUser]
  );

  const handlePageChange = (page) => {
    const nextPage = page;
    fetchOrders(nextPage);
    // console.log(page, "");
    // fetchBusinessData(page);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    // if (!businesslistData.length) return;
    // Update the state first
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset current page to 1
    setSelectedRowsPerPage([]);
    // Now call the function with the updated state
    fetchOrders(1);
  };

  useEffect(() => {
    fetchOrders();
    return () => {
      abortController.abort();
    };
  }, [rowsPerPage, activeCountry, activeBusinessName, searchId, dineIn]);

  useEffect(() => {
    fetchOrders();
  }, [businessObjData]);

  useEffect(() => {
    setActiveBusinessName("")
    setActiveCountry("");
    setSearchId("")
  },[location?.pathname])

  const hideModal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
    setOpen(false);
  };

  const handleToggleStatus = () => { };
  const fetchData = async (obj) => {
    (obj?.table_no == null || obj?.table_no == "") ? setIsTable(false) : setIsTable(true);
    try {      
      setInitialPaymentStatus(obj?.payment_status);
      setInitialOrderStatus(JSON.parse(obj?.status));
      setHasSavedPayment(false);
      setHasSavedOrder(false);
      setOrderId(obj.orderId);
      setBusinessId(obj?.businessId);
      setBusinessname(obj.BusinessName)
      setSelectedOption(JSON.parse(obj?.status));
      setSelectedPaymentOption(obj?.payment_status);
      setContactNo(obj.phone)
      setContactNoCountryCode(obj.countryCode)
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const columns = [
    {
      name: t("OrderId"),
      selector: row => row.orderId,
      sortable: true,
      width: "140px",
    },
    {
      name: t("Restaurant_name"),
      selector: row => row.BusinessName,
      sortable: true,
      width: "200px",
    },
    
    dineIn && {
      name: t("Table_no"),
      selector: row => row.table_no || "--",
      sortable: true,
      width: "120px",
    },
    
    {
      name: t("Total_amount"),
      selector: row => {
        const currency = row?.currency || "";
        const amount =  row?.totalAmount || "--";
        if (amount == null) return "--";

        if (currency === "AED" || currency === "د.") {
          return `${amount} ${currency}`;
        } else {
          return `${currency}${amount}`;
        }
      },
      sortable: true,
      width: "160px",
    },
    dineIn && {
      name: "Transaction ID",
      selector: row => row?.pay_id || "--",
      // sortable: true,
      minWidth: "300px",
    },
    {
      name: t("Date"),
      selector: (row) => {
        const date = new Date(row?.createdAt);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      },
      sortable: true,
      width: '115px'
    },
    {
      name: t("Customer_name"),
      selector: row => row.username,
      sortable: true,
      width: "180px",
    },
    {
      name: t("Phone"),
      selector:  (row) => ((row?.countryCode || "") + (row?.phone || "")) || "--",      
      sortable: true,
      width: '130px'
    },
    {
      name: t("Address"),
      selector: row => row?.address || "--",
      sortable: true,
      width: '220px'
    },
    {
      name: t("Order_status"),
      selector: row=>row.status,
      sortable: true,
      width: '150px',
      cell: (d) => {
        const capitalizedStatus = d?.status ? d?.status.replace(/"/g, '') : '';
        return capitalizedStatus.charAt(0).toUpperCase() + capitalizedStatus.slice(1);
      },
    },
    {
      name: t("Payment_status"),
      selector: row => row?.payment_status || "--",
      sortable: true,
      width: '150px',
      cell: (d) => {
        const capitalizedStatus = d?.payment_status ? d?.payment_status.replace(/"/g, '') : '';
        return capitalizedStatus.charAt(0).toUpperCase() + capitalizedStatus.slice(1);
      },
    },
    {
      name: "Action",
      sortable: false,
      cell: (d) => {
        const isSuperAdmin = userDataObject?.user_type === "super_admin";
        const hasPermission = getUserPermission(userDataObject, 121); // edit permission
        const hasViewPermission = getUserPermission(userDataObject, 120); // view permission
    
        return (
          <>
            {isSuperAdmin && (
              <>
                <i
                  key={`edit-${d?.orderId}`}
                  data-bs-toggle="modal"
                  data-bs-target="#planselect"
                  onClick={() => fetchData(d)}
                  className="first fas fa-pen"
                ></i>
                <i
                  key={`view-${d?.orderId}`}
                  className="first fas fa-eye"
                  onClick={() => handleViewMessage(d)}
                  style={{ cursor: "pointer", margin: "0px" }}
                ></i>
              </>
            )}
    
            {!isSuperAdmin && hasPermission && (
              <i
                key={`edit-${d?.orderId}`}
                data-bs-toggle="modal"
                data-bs-target="#planselect"
                onClick={() => fetchData(d)}
                className="first fas fa-pen"
              ></i>
            )}
    
            {!isSuperAdmin && hasViewPermission && (
              <i
                key={`view-${d?.orderId}`}
                className="first fas fa-eye"
                onClick={() => handleViewMessage(d)}
                style={{ cursor: "pointer", marginRight: "10px" }}
              ></i>
            )}
          </>
        );
      }
    }
    
  ];

  const handleViewMessage = (d) => {
    setOpen(true);
    setSelectedMessage(d);
  };

  const tableData = {
    columns,
    data,
  };
  const handleUpdate = () => { };
  const [editedData, setEditedData] = useState({
    date: new Date(),
  });
  const handleDateChange = (date) => {
    setEditedData({
      ...editedData,
      date: date,
    });
  };
  const handleDropdownChange = (e) => {
    if (e.target.value == "pending") {
      setSelectedOption(e.target.value);
    } else if (e.target.value == "Delivered") {
      setSelectedOption(e.target.value);
    } else if (e.target.value == "confirm") {
      setSelectedOption(e.target.value);
    } else if (e.target.value == "cancel") {
      setSelectedOption(e.target.value);
    }
  };

  const handlePaymentDropdown = (e) => setSelectedPaymentOption(e.target.value);

  const handleSubmit = (e) => {
    setIsSubmit(true);
    let obj = {
      orderId,
      businessname,
      selectedOption,
      businessId
    };
    if (isTable) {
      obj.selectedPaymentOption = selectedPaymentOption;
    }
    axios
      .put(`${baseUrl}api/v1/business/updateorderstatus`, obj, {
        headers: {
          _token: userData?.token,
        },
        withCredentials: true,
      })
      .then((response) => {
        console.log("response", response);
        
        // window.location.reload(5000);
        toast.success(t("Order_status_updated"), {
          position: toast.POSITION.TOP_RIGHT,
        });
        if(!response?.data?.hasTable){
          whatsappclick()
        }
        fetchOrders()
        setIsSubmit(false);
      })
      .catch((error) => {
        console.log(error, "Appointment response");
        setIsSubmit(false);
      });
  };

  const whatsappclick = () => {
    const phoneNumber = contactNoCountryCode + contactNo;
    // const phoneNumber = "8929099255";
    let messageBody = '';

    switch (selectedOption) {
      case "confirm":
        messageBody = `Dear User, 
Your order has been confirmed.`;
        break;
      case "cancel":
        messageBody = `Dear User, 
Your order has been canceled.
We apologize for any inconvenience caused.`;
        break;
      case "Delivered":
        messageBody = `Dear User, 
Your order has been delivered.`;
        break;
      default:
        messageBody = "Your order status has been updated.";
    }
    const message = encodeURIComponent(messageBody);

    const apiUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    window.open(apiUrl, '_blank');

  };

  const handleChangeBusinessData = (e) => {
    setActiveBusinessName(e.target.value);
  };


  useEffect(() => {
    if (selectedDateTo != "" && selectedDateFrom != "") {
      if (selectedDateTo < selectedDateFrom) {
        warning(t("To_date_equal"), {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }
    const filters = {
      businessId: activeBusinessName === "All Business" ? null : activeBusinessName,
      startDate: selectedDateFrom,
      endDate: selectedDateTo,
    };
    fetchOrders(1, filters);
  }, [activeBusinessName, selectedDateFrom, selectedDateTo]);

  const handleSearch = () => {
    loadPageFilter()
    setShowFilter(false);
  };

  const loadPageFilter = () => {
    const nextPage = 1
    setCurrentPage(nextPage);
    fetchOrders(nextPage)
  };

  const handleChangeCountryData = (e) => {
    const countryName = e.target.value;
    setActiveCountry(countryName);
  };

  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: true,
    selectAllRowsItemText: t("All"),
  };

  const getAllBusinessList = () => {
    axios
      .get(`${baseUrl}api/v1/business/getallbusinesslist`, {}, {
        headers: {
          _token: userData?.token,
        },
        withCredentials: true,
      })
      .then((response) => {
        let result = response?.data?.data;
        console.log("resultresultresult", result)
        setBusinesslistData(result);
      })
      .catch((error) => {
        console.log(error);
        setBusinesslistData([])
        // setIsLoading(false);
      });
  }
  useEffect(() => {
    getAllBusinessList();
  }, [])

  return (
    <>
      <PageName PageName={t("Orders")} />
      <article>
        <div className="row d-none">
          <div className="col-md-12">
            <div className="tile">
              <div className="tile-body">
                <form className="row">
                  <div className="mb-2 col-md-3">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search....."
                    />
                  </div>
                  <div className="mb-2 col-md-3">
                    <select className="form-select">
                      <option value="">Select an option</option>
                      <option value="option1">xxx </option>
                      <option value="option2">xxxx</option>
                    </select>
                  </div>
                  <div className="mb-2 col-md-4 align-self-end">
                    <button className="btn btn-primary me-3" type="button">
                      <i className="bi bi-check-circle-fill ms-2 "></i>Search
                    </button>
                    <button className="btn btn-danger" type="button">
                      <i className="bi bi-check-circle-fill me-2"></i>Reset
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <div class="col-md-2">
            <select
              value={activeBusinessName}
              onChange={(e) => setActiveBusinessName(e.target.value)}
              class="form-select"
            >
              <option value="All Business">All Business</option>
              {businesslistData &&
                businesslistData?.length &&
                businesslistData?.map((el, index) => {
                  return <option value={el?.id} key={index}>{el?.title}</option>;
                })}
            </select>
            <div style={{
              fontSize: "14px",
              color: "red",
              bottom: "70px",
            }}>
            </div>
          </div>
          <div class="">
            <select
              style={{ cursor: "pointer" }}
              value={activeCountry}
              onChange={(e) => handleChangeCountryData(e)}
              class="form-select"
            >
              {""}
              <option value={""}>{t("Select_country")}</option>
              {countryData &&
                countryData.map((val, index) => (
                  <option key={index} value={val?.countryCode}>
                    {val?.country}
                  </option>
                ))}
            </select>
          </div>
          <div class="form_control">
            <input type="text" className="form-control" onChange={(e) => setSearchId(e.target.value)} value={searchId} placeholder="OrderId" />
          </div>
        </div>

        <div className="main">
          {isLoading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "55%",
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <CircularLoader size={40} />
            </div>
          ) : (

            <>
              <div className="" style={{ position: 'relative', top: '-64px', width: '70%', left: '20px' }}>

              </div>

              <div className="filter-button-wrapper requestcardfilterbuttonWrapper">
                <span class="FilterIconTextWrapper" onClick={handleFilterOpen}>
                  {" "}
                  <div className="FilterIcon">
                    {" "}
                    <img loading="lazy" src={FilterIcon} width={28} />
                    <div className="filtertext">Filters</div>
                  </div>
                </span>
                {/* <button
                  className="btn btn-primary requestcardfilterbuttonstyle"
                  onClick={handleFilterOpen}
                  id="FilterIconText"
                >
                  Filter
                </button> */}
              </div>
              {/* <Modal
                open={showFilter}
                onClose={handleFilterClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={Boxstyle}>
                  {showFilter && (
                    <div className="Contact_filter_fieldbutton_wrapper ModalPopupContainer">
                      <div className="Contact_filter_field_wrapper ModalPopupWrapper">
                        <div className="col-md-2 Contact_filter_Inputfield" id="ModalSelectfield">
                          <select
                            value={activeBusinessName}
                            onChange={(e) => handleChangeBusinessData(e)}
                            className="form-select"
                          >
                            {" "}
                            <option value={"All Business"}>All Business</option>
                            {businessData &&
                              businessData.map((val, index) => (
                                <option value={val}>{val} </option>
                              ))}
                          </select>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "red",
                              bottom: "70px",
                            }}
                          ></div>
                        </div>


                        <div className="col-md-2 Contact_filter_Inputfield" id="ModalSelectfield">
                          <div className="dateiconmain">
                            <DatePicker
                              placeholderText="From date"
                              selected={selectedDateFrom}
                              onChange={(date) => setSelectedDateFrom(date)}
                              className="form-control"
                              ref={fromDate}
                              dateFormat="dd/MM/yyyy"
                              popperPlacement="bottom-end"
                            />
                            <div
                              className="contact_filter_toDate_calander_icon"
                              onClick={() => fromDate.current.setOpen(true)}
                            >
                              <i className="fa-regular fa-calendar"></i>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2 Contact_filter_Inputfield" id="ModalSelectfield">
                          <div className="dateiconmain">
                            <DatePicker
                              placeholderText="To Date"
                              selected={selectedDateTo}
                              onChange={(date) => setSelectedDateTo(date)}
                              className="form-control"
                              ref={toDate}
                              dateFormat="dd/MM/yyyy"
                              popperPlacement="bottom-end"
                            />
                            <div
                              className="contact_filter_toDate_calander_icon"
                              onClick={() => toDate.current.setOpen(true)}
                            >
                              <i className="fa-regular fa-calendar"></i>
                            </div>
                          </div>
                        </div>
                        <div className="contact_filter_buttonwrapper">

                          <button
                            className="contact_filter_buttonstyle"
                            onClick={() => handleReset()}
                          >
                            Reset{" "}
                          </button>
                          <button
                            class="contact_filter_buttonstyle"
                            onClick={() => handleSearch()}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </Box>
              </Modal> */}

              <div className="scrollable-columns">
                <div className="sticky-header-container">
                  <DataTableExtensions
                    {...tableData}
                    {...tableExtensions}
                    customStyles={customStyles}
                    filterPlaceholder="Search Orders"
                  >
                    <DataTable
                      columns={columns}
                      data={data}
                      noHeader
                      defaultSortField="id"
                      sortIcon={<SortIcon />}
                      defaultSortAsc={true}
                      pagination
                      highlightOnHover
                      paginationServer
                      paginationTotalRows={paginationTotalRows}
                      paginationPerPage={paginationPerPage}
                      paginationRowsPerPageOptions={[10, 20, 50, 100, 300, 1000, 10000]} // Customize as needed
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handleRowsPerPageChange}
                      onSelectedRowsChange={handleOnSelectedRowsChange}
                      dense
                      paginationComponentOptions={{
                        ...paginationOptions,
                      }}
                      customStyles={customStyles}
                      noDataComponent={<div style={{ padding: "24px" }}>{t("No_records_found")}</div>}
                    />
                  </DataTableExtensions>
                </div>
              </div>
            </>
          )}
        </div>
      </article>
      <div
        className="modal fade"
        id="planselect"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content EditStatus_form">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {t("Update_status")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleUpdate}>
                <div className="row g-3 mb-3">
                  <div className="col d-none">
                    <textarea
                      className="form-control"
                      placeholder="Enter Remarks"
                      aria-label="Name"
                    ></textarea>
                  </div>
                  <div className="col">
                    <div className="col">
                    <label htmlFor="type" className="form-label" style={{fontSize:"14px"}}>
                      {t("Order_status")}
                    </label>
                    <select
                      name="type"
                      className="form-select register_inputfield"
                      value={selectedOption}
                      onChange={handleDropdownChange}
                    >
                      <option
                        disabled={
                          initialOrderStatus === "confirm" || 
                          initialOrderStatus === "cancel" ||
                          initialOrderStatus === "Delivered" ||
                          (hasSavedOrder && selectedOption !== "pending")
                        }
                        value="pending">{t("Pending")}</option>
                      <option disabled={initialOrderStatus === "Delivered" || initialOrderStatus === "cancel"} value="confirm">{t("Confirm")} </option>
                      <option disabled={initialOrderStatus === "Delivered"} value="cancel">{t("Cancel")}</option>
                      <option disabled={initialOrderStatus === "cancel"} value="Delivered">{t("Delivered")} </option>
                    </select>
                    </div>
                    { isTable && (
                      <div className="col payment-update" style={{marginTop:"10px"}}>
                      <label htmlFor="type" className="form-label" style={{fontSize:"14px"}}>
                        {t("Payment_status")}
                      </label>
                      <select
                        name="type"
                        className="form-select register_inputfield"
                        value={selectedPaymentOption}
                        onChange={handlePaymentDropdown}
                      >
                        <option
                          disabled={
                            initialPaymentStatus === "complete" || 
                            initialPaymentStatus === "failed" ||
                            (hasSavedPayment && selectedPaymentOption !== "pending")
                          }
                          value="pending">
                            {t("Pending")}
                        </option>
                        <option value="complete">{t("Complete")} </option>
                        {/* <option value="failed">{t("Failed")}</option> */}
                      </select>
                      </div>
                    )}
                  </div>
                  <div className="col d-none">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Plan Name"
                      aria-label="Name"
                      name="txn_id"
                      onChange={(e) => console.log("w")}
                    />
                  </div>
                </div>
                <div class="ChangesEditform">
                  <button
                    type="button"
                    className="btn btn-primary save-cta"
                    data-bs-dismiss="modal"
                    onClick={(e) => handleSubmit(e)}
                  >
                    {isSubmit ? <CircularLoader size={20} /> : t("Save_changes")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => hideModal()}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 500,
            minWidth: 390,
            borderRadius: "md",
            p: 3,
            boxShadow: "lg",
          }}
          className="Infproductdetails"
        >
          <ModalClose
            ref={closeButtonRef}
            variant="plain"
            sx={{ m: 1 }}
            onClick={hideModal}
          />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            fontWeight="lg"
            mb={2}
            textAlign="center"
          >
            {t("Order_details")}
          </Typography>
          <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Order_id")}:</span> <span style={{ fontWeight: "700" }}>#{selectedMessage?.orderId}</span></div>
          <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Order_date")}:</span> <span style={{ fontWeight: "700" }}>{moment(selectedMessage?.created_at).format("DD-MMM-YYYY")}</span></div>
          <div style={{ display: "flex", justifyContent: "space-between" }}><span>Amount To Pay :</span> <span style={{ fontWeight: "700" }}> {selectedMessage?.currency == "AED" ? (
            <>
              {selectedMessage?.totalAmount} {selectedMessage?.currency}
            </>
          ) : (
            <>
              {selectedMessage?.currency}{selectedMessage?.totalAmount}
            </>
          )}</span></div>
          {items && items.length > 0 && items.map((product, index) => (
            <div key={index} className="product-container" style={{ marginBottom: "20px", display: "flex", flexDirection: "column", marginTop: "20px" }}>

              <div style={{ display: "flex" }}>
                <div className="product-info productinfodiv">
                  <img
                    src={`${environmentVariables?.s3UrlBackendUrl}${product?.image}`}
                    alt={product?.name}
                    className="item-image popupproductimg"
                  />
                </div>
                <div>
                  <div className="product-info productinfodiv">
                    <div className="modalcontentdiv">
                      {product?.name}
                    </div>
                  </div>

                  <div className="product-info productinfodiv">
                    <div className="modalcontentdiv">
                      {product?.quantity} x  {selectedMessage?.currency === "AED"
                        ? `${parseFloat(product?.price || 0).toFixed(2)} AED`
                        : `${selectedMessage?.currency || ''}${parseFloat(product?.price || 0).toFixed(2)}`
                      } / {product?.itemSize}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <div>
            <div><h4 style={{marginBottom:'10px'}}> {t("Shipping_address")}</h4></div>
            <div>
              <div>{t("Name")}: <strong>{selectedMessage?.username}</strong></div>
              <div>{t("Phone")}: <strong>{selectedMessage?.countryCode} {selectedMessage?.phone}</strong></div>
              {selectedMessage?.address && (
                <div>
                  {t("Address")}: <strong>{selectedMessage.address}</strong>
                </div>
              )}
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};
export default Adminrestaurantorders;










